var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3875_103491",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4F4F4F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3875_103491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32382 10.4371C6.32382 9.63163 6.31111 8.81962 6.33018 8.01417C6.33653 7.74569 6.25392 7.57543 6.05055 7.40517C5.307 6.77653 4.58251 6.12823 3.85167 5.47994C3.50213 5.17217 3.41316 4.78581 3.58475 4.4322C3.82624 3.94107 4.41092 3.8363 4.85578 4.2161C5.4341 4.71378 5.99336 5.22456 6.56532 5.72878C7.52495 6.57353 8.75785 6.58662 9.71748 5.74188C10.3085 5.22456 10.8868 4.70068 11.4779 4.18991C11.7575 3.94762 12.0752 3.91488 12.393 4.08514C12.6663 4.2292 12.8633 4.57627 12.7807 4.87749C12.7171 5.10014 12.5837 5.34243 12.4184 5.49959C11.6876 6.18062 10.925 6.82236 10.1878 7.49685C10.0797 7.59507 9.99711 7.78498 9.99711 7.93559C9.9844 9.58579 9.99711 11.2294 9.9844 12.8796C9.9844 13.0892 9.9272 13.3184 9.82552 13.4952C9.66664 13.7768 9.3044 13.875 9.01206 13.7899C8.70701 13.6982 8.47823 13.4035 8.47187 13.063C8.45916 12.6046 8.46552 12.1462 8.46552 11.6878C8.46552 11.6027 8.47187 11.511 8.45916 11.4259C8.44009 11.2229 8.37654 11.0526 8.1414 11.0657C7.91262 11.0723 7.83635 11.236 7.83635 11.4455C7.83635 11.9825 7.84271 12.5129 7.83 13.0499C7.82364 13.4559 7.54402 13.7637 7.17542 13.8161C6.80682 13.8684 6.46364 13.6589 6.3556 13.2987C6.31747 13.1743 6.31111 13.0433 6.31111 12.9124C6.31747 12.0742 6.32382 11.2556 6.32382 10.4371Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89572 3.97854C9.89572 4.98045 9.14581 5.7728 8.17982 5.77935C7.20113 5.7859 6.41309 4.98045 6.41309 3.98509C6.41309 2.98974 7.20748 2.17773 8.17347 2.17773C9.12039 2.17773 9.89572 2.98974 9.89572 3.97854Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildBlack);
export default __webpack_public_path__ + "static/media/child_black.c53aed331fe79e133bcdd07b96c211dd.svg";
export { ForwardRef as ReactComponent };